export interface ImageModelOption {
  value: string;
  label: string;
  provider: 'Gemini' | 'OpenAI';
}

export const IMAGE_MODEL_OPTIONS: ImageModelOption[] = [
  { value: 'gemini-3.1-flash-image', label: 'Gemini 3.1 Flash Image', provider: 'Gemini' },
  { value: 'gemini-3-pro-image', label: 'Gemini 3 Pro Image', provider: 'Gemini' },
  { value: 'gpt-image-1', label: 'GPT Image 1', provider: 'OpenAI' },
  { value: 'gpt-image-1.5', label: 'GPT Image 1.5', provider: 'OpenAI' },
  { value: 'gpt-image-1-mini', label: 'GPT Image 1 Mini', provider: 'OpenAI' },
];

export function imageModelLabel(value: string): string {
  const opt = IMAGE_MODEL_OPTIONS.find((o) => o.value === value);
  return opt ? `${opt.label} — ${opt.provider}` : value;
}
